module.exports = `${require.publicPath}img.f998bb98.png`;